const desc = `<p>נחמה פוחצ'יבסקי, <span class="bold">דבר</span> 1934 05 23</p>`;

export default desc;
